"use strict";

require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "StyledTable", {
  enumerable: true,
  get: function get() {
    return _StyledTable["default"];
  }
});
exports["default"] = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.some.js");
require("core-js/modules/es.object.values.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.map.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Sticky = _interopRequireWildcard(require("reactabular-sticky"));
var Table = _interopRequireWildcard(require("reactabular-table"));
var edit = _interopRequireWildcard(require("react-edit"));
var resizable = _interopRequireWildcard(require("reactabular-resizable"));
var search = _interopRequireWildcard(require("@evidation-shared/searchtabular"));
var sort = _interopRequireWildcard(require("sortabular"));
var _icons = require("@evidation/ui/lib/icons");
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _helpers = require("./helpers");
var _ActionCellSpan = _interopRequireDefault(require("./ActionCellSpan"));
var _CSVButton = _interopRequireDefault(require("./CSVButton"));
var _CellSpan = _interopRequireDefault(require("./CellSpan"));
var _NullSelect = _interopRequireDefault(require("./NullSelect"));
var _reactPagify = _interopRequireDefault(require("react-pagify"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StyledTable = _interopRequireDefault(require("./StyledTable"));
var _VisibilityDropdown = _interopRequireDefault(require("./VisibilityDropdown"));
var _redux = require("redux");
var _pivot = _interopRequireDefault(require("./pivot"));
var _segmentize = _interopRequireDefault(require("segmentize"));
var _ui = require("@evidation/ui");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CustomInputWrapper = (0, _styledComponents["default"])(_ui.Input).withConfig({
  displayName: "App__CustomInputWrapper"
})(["width:300px;"]);
var AdvancedTable = /*#__PURE__*/function (_Component) {
  /*
     Notes:
     - infinite scroll overrides resize = true
     - pivot overrides bulk actions
   */

  // TODO - horizontally fixed column(s)
  // TODO - refactor this.props.rowKey to this.state.rowKey

  function AdvancedTable(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AdvancedTable);
    _this = _callSuper(this, AdvancedTable, [props]);
    (0, _defineProperty2["default"])(_this, "searchedRows", function () {
      // For the subtotal, we are limiting by search but not by pagination or whether a record is loaded.
      var query = _this.state.query || '';
      var columns = _this.state.columns.filter(function (column) {
        return column.visible;
      }) || [];
      return search.multipleColumns({
        columns: columns,
        query: query
      })(_this.props.data.data) || [];
    });
    (0, _defineProperty2["default"])(_this, "getRows", function () {
      var data = _this.props.data.data;
      var newData = (0, _lodash.map)(data, function (datum) {
        datum = (0, _lodash.omit)(datum, ['_highlights', '_selected']);
        var _selected = (0, _lodash.findIndex)(_this.state.selectedRows, datum) > -1;
        return (0, _lodash.merge)(datum, {
          _selected: _selected
        });
      });
      return newData;
    });
    (0, _defineProperty2["default"])(_this, "getPageRows", function (rows, page) {
      if (!rows) {
        return [];
      }
      if (!page) {
        page = _this.state.page;
      }
      if (_this.props.overflowStrategy === 'infiniteScroll') {
        return rows.slice(0, page * _this.props.pageSize);
      }
      if (_this.props.overflowStrategy === 'paginated') {
        var startIndex = (page - 1) * _this.props.pageSize;
        var endIndex = startIndex + _this.props.pageSize;
        return rows.slice(startIndex, endIndex);
      }
      return rows;
    });
    (0, _defineProperty2["default"])(_this, "onBodyScroll", function () {
      if (_this.props.overflowStrategy === 'paginated' || _this.props.sticky || _this.props.data.data.length < _this.props.pageSize) {
        return;
      }
      var windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
      var body = document.body;
      var html = document.documentElement;
      var docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
      var windowBottom = windowHeight + window.pageYOffset;
      if (windowBottom + 60 >= docHeight) {
        _this.props.fetchPage(_this.state.page + 1);
        _this.setState({
          page: _this.state.page + 1
        });
      }
    });
    (0, _defineProperty2["default"])(_this, "onTableScroll", function (_ref) {
      var _ref$target = _ref.target,
        scrollHeight = _ref$target.scrollHeight,
        scrollTop = _ref$target.scrollTop,
        offsetHeight = _ref$target.offsetHeight;
      if (scrollTop + offsetHeight === scrollHeight) {
        _this.props.fetchPage(_this.state.page + 1);
        _this.setState({
          page: _this.state.page + 1
        });
      }
    });
    (0, _defineProperty2["default"])(_this, "onPage", function (page) {
      _this.props.fetchPage(page);
      _this.setState({
        page: page
      });
      if (_this.props.overflowStrategy === 'paginated') {
        _this.updatePageSelection(page);
      }
    });
    (0, _defineProperty2["default"])(_this, "onPageClick", function (event) {
      var visibilityDropdownNode = document.getElementById('visibility-dropdown');
      if (_this.state.showList && visibilityDropdownNode && !visibilityDropdownNode.contains(event.target)) {
        _this.setState({
          showList: false
        });
      }
    });
    (0, _defineProperty2["default"])(_this, "getListSearchRows", function (_ref2) {
      var listSearch = _ref2.listSearch,
        columns = _ref2.columns;
      return function (rows) {
        var listSearchResults = [];
        var listSearchArray = listSearch.split('\n');
        (0, _lodash.forEach)(listSearchArray, function (term) {
          var query = {
            all: term
          };
          listSearchResults = (0, _lodash.union)(listSearchResults, search.multipleColumns({
            columns: columns,
            query: query
          })(rows));
        });
        return listSearchResults;
      };
    });
    (0, _defineProperty2["default"])(_this, "onRow", function (row, _ref3) {
      var rowIndex = _ref3.rowIndex;
      return {
        className: "".concat(!!row._selected, "-selected-row"),
        'data-rowindex': rowIndex,
        'data-test': row[_this.props.rowKey],
        onClick: function onClick() {
          return _this.props.bulkActions && !_this.props.pivot ? _this.updateSelected(row) : _this.onSelectRow(row, rowIndex);
        }
      };
    });
    (0, _defineProperty2["default"])(_this, "getSelectedRowIndex", function (selectedRows) {
      return (0, _lodash.findIndex)(_this.props.data.data, selectedRows[0]);
    });
    (0, _defineProperty2["default"])(_this, "onToggleColumn", function (_ref4) {
      var columnIndex = _ref4.columnIndex;
      if (_this.props.bulkActions) {
        columnIndex = columnIndex + 1;
      }
      var columns = (0, _lodash.cloneDeep)(_this.state.columns);
      var column = columns[columnIndex];
      column.visible = !column.visible;
      var query = (0, _lodash.cloneDeep)(_this.state.query);
      delete query[column.property];
      _this.setState({
        columns: columns,
        query: query
      });
    });
    (0, _defineProperty2["default"])(_this, "onToggleList", function () {
      _this.setState({
        showList: !_this.state.showList
      });
    });
    (0, _defineProperty2["default"])(_this, "hasActiveFilters", function (query) {
      return Object.values(query).some(function (field) {
        return field !== '';
      });
    });
    (0, _defineProperty2["default"])(_this, "onSearch", function (query) {
      if (_this.props.handleExternalSearch) {
        _this.props.handleExternalSearch({
          query: query
        });
      }
      var selectedRows = (0, _lodash.cloneDeep)(_this.state.selectedRows);
      var current_rows = (0, _lodash.cloneDeep)(search.multipleColumns({
        columns: _this.state.columns,
        query: query
      })(_this.props.data.data));
      var selectedAll = false;
      if (_this.props.overflowStrategy === 'paginated') {
        current_rows = _this.getPageRows(current_rows);
      }
      if ((0, _lodash.isEqual)(selectedRows, current_rows)) {
        selectedAll = true;
      }
      var newStateValues = {
        query: query,
        selectedAll: selectedAll,
        page: 1
      };
      if (!_this.hasActiveFilters(query) && _this.hasActiveFilters(_this.state.query)) {
        newStateValues.page = _this.state.pageBeforeQuery;
      }
      if (_this.hasActiveFilters(query) && !_this.hasActiveFilters(_this.state.query)) {
        newStateValues = _objectSpread(_objectSpread({}, newStateValues), {}, {
          pageBeforeQuery: _this.state.page
        });
      }
      _this.setState(newStateValues);
    });
    (0, _defineProperty2["default"])(_this, "updatePageSelection", function (page) {
      var rows = search.multipleColumns({
        columns: _this.state.columns,
        query: _this.state.query
      })(_this.props.data.data);
      var currentRows = _this.getPageRows(rows, page);
      var selectedAll = true;
      (0, _lodash.forEach)(currentRows, function (row, key) {
        if ((0, _lodash.findIndex)(_this.state.selectedRows, (0, _lodash.omit)(row, ['_highlights', '_selected'])) === -1) {
          selectedAll = false;
        }
      });
      _this.setState({
        selectedAll: selectedAll
      });
    });
    (0, _defineProperty2["default"])(_this, "updateSelectAll", function () {
      var currentRows;
      if (_this.props.listSearch && _this.props.listSearch !== '') {
        currentRows = (0, _lodash.cloneDeep)(_this.getListSearchRows({
          listSearch: _this.props.listSearch,
          columns: _this.state.columns
        })(_this.props.data.data));
      } else {
        currentRows = (0, _lodash.cloneDeep)(search.multipleColumns({
          columns: _this.state.columns,
          query: _this.state.query
        })(_this.props.data.data));
      }
      var selectedAll = true;
      var selectedRows;
      if (_this.props.overflowStrategy === 'paginated') {
        currentRows = _this.getPageRows(currentRows);
      }
      currentRows = (0, _lodash.map)(currentRows, function (row) {
        return (0, _lodash.omit)(row, ['_highlights', '_selected']);
      });
      if (_this.state.selectedAll) {
        selectedAll = false;
        selectedRows = (0, _lodash.xorWith)(currentRows, _this.state.selectedRows, _lodash.isEqual);
      } else {
        selectedRows = (0, _lodash.cloneDeep)(_this.state.selectedRows);
        (0, _lodash.forEach)(currentRows, function (row) {
          if ((0, _lodash.findIndex)(_this.state.selectedRows, row) === -1) {
            selectedRows.push(row);
          }
        });
      }
      _this.setState({
        selectedAll: selectedAll,
        selectedRows: selectedRows
      });
      _this.props.updateSelected(selectedRows);
    });
    (0, _defineProperty2["default"])(_this, "updateSelected", function (row) {
      var selectedRows = (0, _lodash.cloneDeep)(_this.state.selectedRows);
      var currentRows = (0, _lodash.cloneDeep)(_this.props.data.data);
      var selectedAll = true;
      if (_this.props.overflowStrategy === 'paginated') {
        currentRows = _this.getPageRows(currentRows);
      }
      currentRows = (0, _lodash.map)(currentRows, function (row) {
        return (0, _lodash.omit)(row, ['_highlights', '_selected']);
      });
      var cleanRow = row['rowData'] || row;
      cleanRow = (0, _lodash.omit)(cleanRow, ['_highlights', '_selected']);
      var index = (0, _lodash.findIndex)(selectedRows, cleanRow);
      if (index > -1) {
        selectedRows.splice(index, 1);
      } else {
        selectedRows.push(cleanRow);
      }
      (0, _lodash.forEach)(currentRows, function (row) {
        if ((0, _lodash.findIndex)(selectedRows, row) === -1) {
          selectedAll = false;
        }
      });
      _this.setState({
        selectedRows: selectedRows,
        selectedAll: selectedAll
      });
      _this.props.updateSelected(selectedRows);
    });
    (0, _defineProperty2["default"])(_this, "renderBody", function (formatted_rows) {
      var rowKey = _this.props.rowKey;
      if (rowKey === 'id') {
        var has_id = _this.props.data.data.filter(function (row) {
          return row.id;
        });
        if (has_id.length === 0 && _this.state.columns[0]) {
          rowKey = _this.state.columns[0].cell.property;
        }
      }
      if (_this.props.sticky) {
        return /*#__PURE__*/_react["default"].createElement(Sticky.Body, {
          onRow: _this.onRow,
          onScroll: _this.onTableScroll,
          style: {
            maxWidth: 1200,
            maxHeight: 400
          },
          rows: formatted_rows,
          rowKey: rowKey
        });
      }
      return /*#__PURE__*/_react["default"].createElement(Table.Body, {
        onRow: _this.onRow,
        rows: formatted_rows,
        rowKey: rowKey
      });
    });
    (0, _defineProperty2["default"])(_this, "renderColumnToggles", function () {
      if (_this.props.hideColumns) {
        return /*#__PURE__*/_react["default"].createElement(_VisibilityDropdown["default"], {
          columns: _this.state.columns,
          onToggleColumn: _this.onToggleColumn,
          showList: _this.state.showList,
          toggleList: _this.onToggleList
        });
      }
      return null;
    });
    (0, _defineProperty2["default"])(_this, "renderDownload", function () {
      if (_this.props.download) {
        return /*#__PURE__*/_react["default"].createElement(_CSVButton["default"], {
          columns: _this.props.data.columns,
          data: _this.props.data.data,
          filename: _this.props.filename
        });
      }
      return null;
    });
    (0, _defineProperty2["default"])(_this, "renderHeader", function (searchColumns) {
      if (_this.props.sticky) {
        return /*#__PURE__*/_react["default"].createElement(Sticky.Header, {
          className: "sticky-header",
          style: {
            maxWidth: 1200,
            overflowY: 'scroll'
          }
        }, /*#__PURE__*/_react["default"].createElement(search.Columns, {
          columns: searchColumns,
          query: _this.state.query,
          onChange: _this.onSearch
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(Table.Header, null, /*#__PURE__*/_react["default"].createElement(search.Columns, {
        columns: searchColumns,
        query: _this.state.query,
        onChange: _this.onSearch
      }));
    });
    (0, _defineProperty2["default"])(_this, "renderNextButton", function (page, pages) {
      if (page > pages) {
        return /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Button, {
          className: "disabled",
          page: page - 1
        }, "Next");
      }
      return /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Button, {
        page: page
      }, "Next");
    });
    (0, _defineProperty2["default"])(_this, "renderPreviousButton", function (page) {
      if (page > 0) {
        return /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Button, {
          page: page
        }, "Previous");
      }
      return /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Button, {
        className: "disabled",
        page: 1
      }, "Previous");
    });
    (0, _defineProperty2["default"])(_this, "renderPaginator", function (rowCount) {
      if (_this.props.overflowStrategy === 'paginated') {
        var currentPage = _this.state.page || 1;
        if (currentPage === 1 && _this.props.data.data.length <= _this.props.pageSize) {
          return null;
        }
        if (!_this.props.showPaginationControls) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Context, {
          className: "pagify-pagination",
          segments: (0, _segmentize["default"])({
            beginPages: 2,
            endPages: 1,
            page: currentPage,
            pages: Math.ceil(rowCount / _this.props.pageSize),
            sidePages: 2
          }),
          onSelect: function onSelect(page) {
            return _this.onPage(page);
          },
          tags: {
            container: {
              tag: 'ul'
            },
            segment: {
              tag: 'li'
            },
            ellipsis: {
              tag: 'li'
            },
            link: {
              tag: 'span'
            }
          }
        }, _this.renderPreviousButton(currentPage - 1), /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Segment, {
          field: "beginPages"
        }), /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Ellipsis, {
          className: "ellipsis",
          previousField: "beginPages",
          nextField: "previousPages"
        }), /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Segment, {
          field: "previousPages"
        }), /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Segment, {
          field: "centerPage",
          style: {
            fontWeight: 'bold'
          }
        }), /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Segment, {
          field: "nextPages"
        }), /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Ellipsis, {
          previousField: "nextPages",
          nextField: "endPages"
        }), /*#__PURE__*/_react["default"].createElement(_reactPagify["default"].Segment, {
          field: "endPages"
        }), _this.renderNextButton(currentPage + 1, Math.ceil(rowCount / _this.props.pageSize)));
      }
      return null;
    });
    (0, _defineProperty2["default"])(_this, "renderSearch", function (cols) {
      if (_this.props.globalSearch) {
        var _this$state = _this.state,
          query = _this$state.query,
          rows = _this$state.rows,
          searchColumn = _this$state.searchColumn;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "search-container"
        }, /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
          items: "center"
        }, /*#__PURE__*/_react["default"].createElement(_icons.Search, {
          style: {
            transform: "translateX(25px)",
            width: 14,
            height: 14,
            color: _ui.color.text.secondary
          }
        }), /*#__PURE__*/_react["default"].createElement(search.Field, {
          column: searchColumn,
          columns: cols,
          components: {
            select: _NullSelect["default"],
            filter: CustomInputWrapper,
            props: {
              filter: {
                placeholder: 'Search',
                inline: true,
                style: {
                  paddingLeft: 24
                }
              }
            }
          },
          onColumnChange: function onColumnChange(searchColumn) {
            return _this.setState({
              searchColumn: searchColumn
            });
          },
          onChange: _this.onSearch,
          query: query,
          rows: rows
        })));
      }
      return null;
    });
    (0, _defineProperty2["default"])(_this, "renderSelected", function (rows, selectedRows) {
      if (_this.props.pivot || !_this.props.bulkActions) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("p", null, "Selected Records: ", selectedRows.length, " of ", rows.length);
    });
    _this.state = {
      columns: [],
      query: {},
      page: _this.props.page,
      pages: 0,
      selectedAll: false,
      selectedRows: _this.props.selectedRows || [],
      sortingColumns: null,
      showList: false,
      pageBeforeQuery: 1
    };
    return _this;
  }
  (0, _inherits2["default"])(AdvancedTable, _Component);
  return (0, _createClass2["default"])(AdvancedTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.page !== this.props.page) {
        this.onPage(this.props.page);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        columns: this.getColumns()
      });
      window.addEventListener('scroll', this.onBodyScroll);
      window.addEventListener('click', this.onPageClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onBodyScroll);
      window.removeEventListener('click', this.onPageClick);
    }
  }, {
    key: "getColumns",
    value: function getColumns() {
      var _this2 = this;
      /*
         Support array of objects or array of strings
         Supports the following fields in each column object:
         For Header and Row Markup: name, label (expected)
         For Cell linking and styling: href_field, link_icon,
         content_type (text, number, date),
         For Column-specific options: edit, resize, search, sort, subtotal
         Adjusts options based on table props:
         hideColumns, globalSearch, download, edit, resize,
         search, sort, subtotal
         Column-specific options override the table default
         except resize if overflow strategy is infinitescroll
         Adds select column if bulkActions = true
       */

      if (!this.props.data.columns) {
        return [];
      }
      var columns = [];
      var col, isEditable, isSearchable, isSortable, isResizable, hasSubtotal;
      var editable = edit.edit({
        isEditing: function isEditing(_ref5) {
          var columnIndex = _ref5.columnIndex,
            rowData = _ref5.rowData;
          return columnIndex === rowData.editing;
        },
        onActivate: function onActivate(_ref6) {
          var columnIndex = _ref6.columnIndex,
            rowData = _ref6.rowData;
          var index = (0, _lodash.findIndex)(_this2.props.data.data, [_this2.props.rowKey, rowData[_this2.props.rowKey]]);
          var rows = (0, _lodash.cloneDeep)(_this2.props.data.data);
          rows[index].editing = columnIndex;
          _this2.setState({
            rows: rows
          });
        },
        onValue: function onValue(_ref7) {
          var value = _ref7.value,
            rowData = _ref7.rowData,
            property = _ref7.property;
          var index = (0, _lodash.findIndex)(_this2.props.data.data, [_this2.props.rowKey, rowData[_this2.props.rowKey]]);
          var rows = (0, _lodash.cloneDeep)(_this2.props.data.data);
          if (rowData["_".concat(property, "_siblings")]) {
            var siblingsCount = rowData["_".concat(property, "_siblings")];
            (0, _lodash.forEach)(rows.slice(index, siblingsCount), function (siblingRow) {
              siblingRow[property] = value;
              _this2.props.saveChange(siblingRow);
            });
          } else {
            rows[index][property] = value;
            _this2.props.saveChange(rows[index]);
          }
          rows[index].editing = false;
          _this2.setState({
            rows: rows
          });
        }
      });
      var sortable = sort.sort({
        getSortingColumns: function getSortingColumns() {
          return _this2.state.sortingColumns || [];
        },
        onSort: function onSort(selectedColumn) {
          _this2.props.handleExternalSort({
            sortingColumns: sort.byColumns({
              sortingColumns: _this2.state.sortingColumns,
              selectedColumn: selectedColumn
            }),
            columns: (0, _toConsumableArray2["default"])(_this2.state.columns).filter(function (c) {
              return c.visible;
            })
          });
          _this2.setState({
            sortingColumns: sort.byColumns({
              // sort.byColumn would work too
              sortingColumns: _this2.state.sortingColumns,
              selectedColumn: selectedColumn
            })
          });
        }
      });
      var sortableHeader = sortHeader(sortable, function () {
        return _this2.state.sortingColumns;
      });
      var resize = resizable.column({
        getWidth: function getWidth(column) {
          return column.header.props.style.width;
        },
        onDrag: function onDrag(width, _ref8) {
          var columnIndex = _ref8.columnIndex;
          var columns = _this2.state.columns;
          var column = columns[columnIndex];
          column.header.props.style = _objectSpread(_objectSpread({}, column.header.props.style), {}, {
            width: width
          });
          _this2.setState({
            columns: columns
          });
        }
      });

      // if bulkActions, add bulk action column first
      // bulkActions overridden by pivot
      if (this.props.bulkActions && !this.props.pivot) {
        columns.push({
          property: 'select',
          header: {
            transforms: [function () {
              return {
                children: /*#__PURE__*/_react["default"].createElement("input", {
                  type: "checkbox",
                  checked: _this2.state.selectedAll,
                  onChange: _this2.updateSelectAll
                })
              };
            }],
            searchable: false,
            sortable: false,
            props: {
              style: {
                minWidth: 30
              }
            }
          },
          cell: {
            property: 'bulkSelect',
            formatters: [function (key, row) {
              return /*#__PURE__*/_react["default"].createElement("input", {
                type: "checkbox",
                checked: row.rowData._selected,
                value: key,
                onChange: function onChange() {
                  _this2.updateSelected(row);
                }
              });
            }]
          },
          visible: true
        });
      }
      this.props.data.columns.forEach(function (column) {
        hasSubtotal = column.subtotal === undefined ? _this2.props.subtotal : column.subtotal;
        isEditable = column.edit === undefined ? _this2.props.edit : column.edit;
        if (_this2.props.pivot) {
          isEditable = false;
        }
        isResizable = column.resize === undefined ? _this2.props.resize : column.resize;
        isSortable = column.sort === undefined ? _this2.props.sort : column.sort;
        isSearchable = column.search === undefined ? _this2.props.search : column.search;
        if (_this2.props.sticky) {
          isResizable = false;
        }
        if (typeof column === 'string') {
          column = {
            label: (0, _helpers.deslugify)(column),
            name: (0, _helpers.slugify)(column)
          };
        }
        col = {
          property: column['name'],
          header: {
            label: column['label'],
            searchable: isSearchable,
            sortable: column,
            props: {
              'data-test': column['name'],
              style: {
                minWidth: column['min_width'] || 150
              }
            }
          },
          props: {
            'data-test': column['name'],
            style: {
              minWidth: column['min_width'] || 150
            }
          },
          visible: column['visible'] !== undefined ? column['visible'] : true
        };
        if (_this2.props.sticky) {
          col['header']['props']['style']['minWidth'] = column['min_width'] || 150;
        }
        if (isResizable && isSortable) {
          col['header']['formatters'] = [function (v, extra) {
            return resize(sortableHeader(v, extra), extra);
          }];
        } else if (isResizable) {
          col['header']['formatters'] = [function (v, extra) {
            return resize(v, extra);
          }];
        } else if (isSortable) {
          col['header']['formatters'] = [function (v, extra) {
            return sortableHeader(v, extra);
          }];
        }
        col['cell'] = {
          property: column['name'],
          formatters: [function (key, row) {
            return /*#__PURE__*/_react["default"].createElement(_CellSpan["default"], {
              value: key,
              row: row,
              column: column,
              customCells: _this2.props.customCells
            });
          }]
        };
        col['cell']['transforms'] = [];
        if (_this2.props.pivot) {
          col['cell']['transforms'].push(function (value, _ref9) {
            var column = _ref9.column,
              rowData = _ref9.rowData;
            var columnName = column['cell']['property'];
            var hiddenVar = "_".concat(columnName, "_hide");
            var siblingVar = "_".concat(columnName, "_siblings");
            var properties = {
              style: {}
            };
            if (rowData[siblingVar]) {
              properties['rowSpan'] = rowData[siblingVar];
            }
            if (rowData[hiddenVar]) {
              properties['style']['display'] = 'none';
            }
            return properties;
          });
        }
        if (isEditable) {
          col['cell']['transforms'].push(editable(edit.input()));
        }
        if (hasSubtotal) {
          _this2.renderFooter = true;
          if (column['content_type'] === 'number') {
            col['footer'] = function () {
              return "".concat(_this2.searchedRows().reduce(function (a, b) {
                return (0, _helpers.numberify)(a) + (0, _helpers.numberify)(b[column['name']]);
              }, 0));
            };
          } else {
            col['footer'] = function (rows) {
              return "".concat(_this2.searchedRows().filter(function (row) {
                return !!row[column['name']];
              }).length);
            };
          }
        }
        columns.push(col);
      });
      if (this.props.actions.length > 0) {
        columns.push({
          property: 'actions',
          header: {
            label: 'Actions',
            searchable: false,
            sortable: false,
            props: {
              style: {
                minWidth: 150
              }
            }
          },
          cell: {
            formatters: [function (key, row) {
              return /*#__PURE__*/_react["default"].createElement(_ActionCellSpan["default"], {
                value: key,
                row: row,
                actions: _this2.props.actions
              });
            }]
          },
          props: {
            className: "col_actions",
            style: {
              minWidth: 150
            }
          },
          visible: true
        });
      }
      return columns;
    }
  }, {
    key: "onSelectRow",
    value: function onSelectRow(row, selectedRowIndex) {
      var rows = (0, _lodash.cloneDeep)(this.props.data.data);
      var selectedRow = row;
      if (this.props.pivot) {
        var firstColumnName = this.state.columns[0].property;
        var firstColumnValue = selectedRow[firstColumnName];

        // missing the _ pivot props in rows
        // can do a quick query of first column prop for index +1 and
        // index -1 until different, and select all with the same first index value
        var siblingRows = [selectedRow];
        // count up
        for (var i = selectedRowIndex + 1; i < rows.length; i++) {
          if (rows[i][firstColumnName] === firstColumnValue) {
            siblingRows.push(rows[i]);
          } else {
            break;
          }
        }
        // count down
        for (var _i = selectedRowIndex - 1; _i > -1; _i--) {
          if (rows[_i][firstColumnName] === firstColumnValue) {
            siblingRows.push(rows[_i]);
          } else {
            break;
          }
        }
        if ((0, _lodash.isEqual)(this.state.selectedRows, siblingRows)) {
          this.setState({
            selectedRows: []
          });
          this.props.updateSelected([]);
        } else {
          this.setState({
            selectedRows: siblingRows
          });
          this.props.updateSelected(siblingRows);
        }
      } else {
        if (!(0, _lodash.some)(this.state.selectedRows, selectedRow)) {
          this.setState({
            selectedRows: [selectedRow]
          });
          this.props.updateSelected([selectedRow]);
        } else {
          this.setState({
            selectedRows: []
          });
          this.props.updateSelected([]);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props, _this$props2, _this$props2$external;
      var _this$state2 = this.state,
        columns = _this$state2.columns,
        query = _this$state2.query,
        selectedRows = _this$state2.selectedRows,
        sortingColumns = _this$state2.sortingColumns;
      var rows = this.getRows();
      var cols = columns.filter(function (column) {
        return column.visible;
      });
      var searchColumns = cols.map(function (column) {
        if (column.header.searchable) {
          return column;
        }
        column['property'] = false;
        return column;
      });
      var formattedRows, matchingRowCount;
      if (this.props.listSearch && this.props.listSearch !== '') {
        formattedRows = (0, _redux.compose)(sort.sorter({
          columns: cols,
          sortingColumns: sortingColumns,
          sort: _lodash.orderBy
        }), this.getListSearchRows({
          listSearch: this.props.listSearch,
          columns: cols
        }))(rows);
        matchingRowCount = formattedRows.length;
        this.props.filterChange(formattedRows);
      } else {
        formattedRows = (0, _redux.compose)(search.highlighter({
          columns: cols,
          matches: search.matches,
          query: query
        }), search.multipleColumns({
          columns: cols,
          query: query
        }), sort.sorter({
          columns: cols,
          sortingColumns: sortingColumns,
          sort: _lodash.orderBy
        }))(rows);
        matchingRowCount = search.multipleColumns({
          columns: cols,
          query: query
        })(rows).length;
        this.props.filterChange(formattedRows);
      }
      var formattedPageRows = this.getPageRows(formattedRows);
      if (this.props.pivot) {
        (0, _pivot["default"])(formattedPageRows, cols);
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
        items: "center",
        style: {
          marginBottom: '1rem'
        },
        spaceX: 4
      }, !this.props.externalTitle && /*#__PURE__*/_react["default"].createElement("div", {
        className: "record-counter"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Matching Records: ", matchingRowCount, " of ", rows.length), this.renderSelected(rows, selectedRows)), (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.externalTitle, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginRight: 'auto'
        }
      }), /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
        style: {
          position: 'relative'
        }
      }, this.renderSearch(cols), this.props.searchLoading && /*#__PURE__*/_react["default"].createElement(_ui.LoadingIndicator, {
        width: 36,
        height: 36,
        style: {
          position: 'absolute',
          right: 0,
          marginRight: '.5rem'
        }
      })), (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$external = _this$props2.externalControls) === null || _this$props2$external === void 0 ? void 0 : _this$props2$external.call(_this$props2), this.renderColumnToggles(), this.renderDownload()), /*#__PURE__*/_react["default"].createElement("div", {
        className: "table-container"
      }, /*#__PURE__*/_react["default"].createElement(Table.Provider, {
        columns: cols
      }, this.renderHeader(searchColumns), this.renderBody(formattedPageRows), /*#__PURE__*/_react["default"].createElement(CustomFooter, {
        render: this.renderFooter,
        columns: cols,
        rows: formattedPageRows
      }))), this.renderPaginator(matchingRowCount));
    }
  }]);
}(_react.Component);
var CustomFooter = function CustomFooter(_ref10) {
  var columns = _ref10.columns,
    render = _ref10.render,
    rows = _ref10.rows;
  if (render) {
    return /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, columns.map(function (column, i) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: "footer-".concat(i)
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "cell-right"
      }, /*#__PURE__*/_react["default"].createElement("span", null, column.footer ? column.footer(rows) : i === 0 && 'Total')));
    })));
  }
  return null;
};
function sortHeader(sortable, getSortingColumns) {
  return function (value, _ref11) {
    var columnIndex = _ref11.columnIndex;
    var sortingColumns = getSortingColumns() || [];
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'inline'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "value"
    }, value), /*#__PURE__*/_react["default"].createElement('span', sortable(value, {
      columnIndex: columnIndex
    }, {
      style: {
        right: '5px'
      }
    })), sortingColumns[columnIndex] && /*#__PURE__*/_react["default"].createElement("span", {
      className: "sort-order",
      style: {
        marginLeft: '0.5em'
      }
    }, sortingColumns[columnIndex].position + 1));
  };
}
AdvancedTable.defaultProps = {
  actions: [],
  bulkActions: false,
  customCells: {},
  data: {},
  download: false,
  edit: false,
  fetchPage: function fetchPage() {
    return;
  },
  filename: 'export.csv',
  filterChange: function filterChange() {
    return null;
  },
  handleExternalSearch: function handleExternalSearch() {},
  handleExternalSort: function handleExternalSort() {},
  hideColumns: false,
  globalSearch: false,
  overflowStrategy: 'infiniteScroll',
  page: 1,
  pageSize: 20,
  pivot: false,
  resize: false,
  rowKey: 'id',
  saveChange: function saveChange() {
    return null;
  },
  search: false,
  showPaginationControls: true,
  sort: false,
  sticky: false,
  subtotal: false,
  updateSelected: function updateSelected() {
    return null;
  }
};
AdvancedTable.propTypes = {
  actions: _propTypes["default"].array,
  bulkActions: _propTypes["default"].bool,
  customCells: _propTypes["default"].object,
  data: _propTypes["default"].object,
  download: _propTypes["default"].bool,
  edit: _propTypes["default"].bool,
  fetchPage: _propTypes["default"].func,
  filename: _propTypes["default"].string,
  filterChange: _propTypes["default"].func,
  hideColumns: _propTypes["default"].bool,
  globalSearch: _propTypes["default"].bool,
  listSearch: _propTypes["default"].string,
  overflowStrategy: _propTypes["default"].string,
  page: _propTypes["default"].number,
  pageSize: _propTypes["default"].number,
  pivot: _propTypes["default"].bool,
  resize: _propTypes["default"].bool,
  rowKey: _propTypes["default"].string,
  saveChange: _propTypes["default"].func,
  search: _propTypes["default"].bool,
  handleExternalSearch: _propTypes["default"].func,
  handleExternalSort: _propTypes["default"].func,
  searchLoading: _propTypes["default"].bool,
  showPaginationControls: _propTypes["default"].bool,
  sort: _propTypes["default"].bool,
  sticky: _propTypes["default"].bool,
  subtotal: _propTypes["default"].bool,
  updateSelected: _propTypes["default"].func
};
var _default = exports["default"] = AdvancedTable;